import { createHook, createStore } from 'react-sweet-state';

import type { Conversation } from '../../../types';

type State = {
	isOpen: boolean;
	conversation: Conversation;
	mode: 'edit' | 'delete';
};

const store = createStore({
	initialState: {
		isOpen: false,
		conversation: {},
		mode: 'edit',
	} as State,
	actions: {
		openModal:
			(conversation: Conversation, mode: 'edit' | 'delete') =>
			({ setState }) => {
				setState({ isOpen: true, conversation, mode });
			},
		closeModal:
			() =>
			({ setState }) => {
				setState({ isOpen: false });
			},
	},
});

const useStore = createHook(store);

export const useConversationModal = (): {
	isOpen: boolean;
	conversation: Conversation;
	mode: 'edit' | 'delete';
	openModal: (conversation: Conversation, mode: 'edit' | 'delete') => void;
	closeModal: () => void;
} => {
	const [state, actions] = useStore();

	return {
		isOpen: state.isOpen,
		conversation: state.conversation,
		mode: state.mode,
		openModal: actions.openModal,
		closeModal: actions.closeModal,
	};
};
